export interface Menu {
  [key: string]: unknown;
}

export interface PermissionMenusState {
  userMenus: Menu[];
  error: string | null;
  loading: boolean;
}

export const initialState: PermissionMenusState = {
  userMenus: [],
  error: null,
  loading: false,
};
